import { render } from "./exams-list.vue?vue&type=template&id=1d365a59&scoped=true"
import script from "./exams-list.vue?vue&type=script&lang=js"
export * from "./exams-list.vue?vue&type=script&lang=js"

import "./exams-list.vue?vue&type=style&index=0&id=1d365a59&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d365a59"]])

export default __exports__